import { render, staticRenderFns } from "./valueRuleDialog.vue?vue&type=template&id=004823c2"
import script from "./valueRuleDialog.vue?vue&type=script&lang=js"
export * from "./valueRuleDialog.vue?vue&type=script&lang=js"
import style0 from "./valueRuleDialog.vue?vue&type=style&index=0&id=004823c2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports